module.exports = __webpack_public_path__ + "static/media/InConnection.0f8d3dda.png";